// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Thanks_wrapper__1615H","image_thanks":"Thanks_image_thanks__1Fi1D","title":"Thanks_title__3tmNM","subtitle":"Thanks_subtitle__2POOm"};